var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"component"},[(_vm.$slots.title)?_c(_setup.Title,{class:_vm.titleClassname,attrs:{"size":"8"}},[_vm._t("title")],2):_vm._e(),_vm._v(" "),(_vm.$slots.subtitle)?_c(_setup.Subtitle,{class:_vm.subtitleClassname,attrs:{"size":"5"}},[_vm._t("subtitle")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }